var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-dialog',_vm._g(_vm._b({ref:"elForm",attrs:{"title":_vm.dialogTitle,"width":"80%"},on:{"open":_vm.onOpen,"close":_vm.onClose}},'el-dialog',_vm.$attrs,false),_vm.$listeners),[_c('LogList',{ref:"refLogList",attrs:{"info-id":_vm.infoId}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }